import { render, staticRenderFns } from "./data-subject-preference-history.vue?vue&type=template&id=77c9e59a&scoped=true"
import script from "./data-subject-preference-history.vue?vue&type=script&lang=js"
export * from "./data-subject-preference-history.vue?vue&type=script&lang=js"
import style0 from "./data-subject-preference-history.vue?vue&type=style&index=0&id=77c9e59a&prod&scoped=true&lang=css"
import style1 from "./data-subject-preference-history.vue?vue&type=style&index=1&id=77c9e59a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c9e59a",
  null
  
)

export default component.exports